import React, { useState, useEffect } from "react";
import { Container, Typography, Box, Avatar, IconButton } from "@mui/material";
import styles from "./Testimonial.module.css";
import AR from "../../asset/AR.png";
import JD from "../../asset/JD.jpeg";
import SL from "../../asset/SL.jpeg";
import Quote from "../../asset/quote.png";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const testimonials = [
  {
    name: "Robert",
    avatar: JD,
    text:
      "E-Learning & Development Bot : The AI-powered e-learning bot transformed our training delivery. Course creation time dropped by over 60%, while learner engagement and assessment accuracy significantly improved. Personalized learning paths made skill development measurable and scalable",

  },
  {
    name: "Priya",
    avatar: SL,
    text:
      "Education Bot : This AI education bot enabled us to deliver consistent, high-quality academic support across thousands of students. Automated content explanation, doubt resolution, and progress analytics improved learning outcomes without increasing faculty load.",
  },
  {
    name: "Ankit",
    avatar: JD,
    text:
      "HR Process Bot (Code of Conduct): “The Code of Conduct AI bot streamlined policy awareness and compliance across our organization. Employees now receive instant, contextual guidance, and audit-ready reports helped us reduce policy violations and investigation cycles.”",
  },
  {
    name: "Sarah",
    avatar: SL,
    text:
      "Healthcare Bot: “The healthcare AI bot improved clinical documentation accuracy and patient interaction workflows. It reduced administrative burden on clinicians while ensuring compliance, traceability, and faster decision support.”",
  },
  {
    name: "Rohan",
    avatar: JD,
    text:
      "Manufacturing Bot: “Our manufacturing operations benefited from real-time insights and automated process validation. The AI bot helped identify deviations early, improved SOP adherence, and reduced operational downtime across plants.”",
  },
  {
    name: "Swapnil",
    avatar: JD,
    text:
      "VoiceBot: “The VoiceBot delivered human-like conversations at scale, handling customer queries efficiently while maintaining compliance. Call handling time reduced drastically, and customer satisfaction scores improved consistently.”",
  },
  {
    name: "Sophia",
    avatar: SL,
    text:
      "ClinicalBot: “ClinicalBot accelerated protocol review, data validation, and regulatory documentation. It significantly reduced manual review cycles while maintaining scientific accuracy and audit readiness.”",
  },
  {
    name: "Michael",
    avatar: JD,
    text:
      "Document Generator Bot: “The AI document generator cut document creation time from weeks to hours. It ensured structured, compliant, and consistent outputs across regulatory, technical, and business documents with minimal manual intervention.”",

  },
];

const Testimonial = () => {
  const [index, setIndex] = useState(0);

  const next = () =>
    setIndex((prev) => (prev + 1) % testimonials.length);

  const prev = () =>
    setIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );

  // Auto-play (safe & smooth)
  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Container
      id="testimonials"
      maxWidth={false}
      sx={{
        backgroundColor: "#1e1e1e", 
        py: { xs: 8, md: 12 },
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Typography variant="h3" className={styles.heading}>
        Some Of Our Testimonials
      </Typography>

      {/* Slider viewport */}
      <Box className={styles.slider}>
        <Box
          className={styles.track}
          style={{
            transform: `translateX(-${index * 100}%)`,
          }}
        >
          {testimonials.map((t, i) => (
            <Box key={i} className={styles.slide}>
              <Box className={styles.testimonialBox}>
                <Avatar src={t.avatar} className={styles.avatar} />
                {/* <Box className={styles.quoteIconContainer}>
                  <img src={Quote} alt="quote" className={styles.quoteImage} />
                </Box> */}

                <Typography className={styles.name}>
                  {t.name}
                </Typography>

                <Typography className={styles.description}>
                  "{t.text}"
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Arrows */}
      <IconButton
        onClick={prev}
        className={styles.arrowLeft}
      >
        <ChevronLeftIcon />
      </IconButton>

      <IconButton
        onClick={next}
        className={styles.arrowRight}
      >
        <ChevronRightIcon />
      </IconButton>

      {/* Dots */}
      <Box className={styles.dots}>
        {testimonials.map((_, i) => (
          <span
            key={i}
            className={`${styles.dot} ${
              i === index ? styles.activeDot : ""
            }`}
            onClick={() => setIndex(i)}
          />
        ))}
      </Box>
    </Container>
  );
};

export default Testimonial;